export default {
  //
  // ============================================================================
  // LOGIN HEADER - Заглавна секција на страницата за најава
  // ============================================================================
  //
  loginHeader: {
    labSubtitle: "Лабораториски информациски систем",
    defaultLabName: "Лабораториски портал",
    defaultLogoAlt: "Лого на лабораторијата",
    signIn: "Најава",
    openMenu: "Отвори мени",
    language_section: {
      title: "Избирање на јазик",

      languages: {
        en: "Англиски",
        bg: "Бугарски",
        mk: "Македонски",
      },
    },
  },

  //
  // ============================================================================
  // LOGIN FORM - Формулар за најава
  // ============================================================================
  //
  loginForm: {
    title: "Веб портал за онлајн резултати",
    description:
      "Симнете ги вашите резултати онлајн, без да губите време во повторни посети. За лекари и медицински партнери - специјални функции за следење на пациентите.",
    loginButtonText: "Најава",
    agreeTerms: "Се согласувам со",
    termsOfUse: "Условите за користење",
    termsOfUseTooltip: "Преглед на условите за користење",
    termsDialogTitle: "Условите за користење",
    termsDialogOk: "ОК",
    termsLoadingError: "Неуспешно вчитување на условите за користење. Обидете се повторно.",
    termsLoadingText: "Вчитување на условите за користење...",
    scrollToBottom: "Ве молиме скролајте до крајот за да продолжите",
    scrollToBottomButton: "Скролање до крај",
  },

  //
  // ============================================================================
  // LOGIN FOOTER - Долна секција на страницата за најава
  // ============================================================================
  //
  loginFooter: {
    // === General Information ===
    subtitle: "Лабораториски информациски систем",
    poweredBy: "Напојуван од",
    description:
      "Модерна LIMS платформа за управување со лабораториски процеси, тестови и резултати.",
    disclaimer:
      "Системот е достапен само за овластени корисници. За податоци за пристап контактирајте ја лабораторијата.",

    // === Resources Section ===
    resources: "Медицински услуги",
    labTests: "Тестови",
    labTestsTooltip: "Преглед на каталогот на лабораториски тестови",
    pricing: "Ценовник",
    pricingTooltip: "Преглед на цени и пакети",
    covidTesting: "COVID-19",
    covidTestingTooltip: "Услуги за COVID-19 тестирање",
    documentation: "Документација",
    documentationTooltip: "Преглед на документацијата",

    // === Product Information ===
    lisILab: "LIMS iLab",
    limsILabTooltip: "LIMS iLab - Лабораториски информациски систем",

    // === Contact Section ===
    connect: "Контактирајте не",
    locationDetails: "Софија, бул. Витоша 1",
    locationDetailsTooltip: "Посета",
    phone: "Телефон",
    phoneNumber: "+359 2 XXX XXXX",
    phoneTooltip: "Јавување",
    email: "Е-пошта",
    emailAddress: "info-precisio.bg",
    emailTooltip: "Испраќање на е-пошта",
    workingHoursDetails: "Пон-Пет: 07:30-19:00",
    workingHoursTooltip: "Работно време на лабораторијата",

    // === Company & Copyright ===
    skywareGroup: "SKYWARE Group",
    skywareGroupUrl: "https://skyware-group.com",
    skywareGroupTooltip: "Посета на веб-сајтот на SKYWARE Group",
    github: "GitHub",
    nuget: "NuGet",
    copyrightPrefix: "Авторски права ©",
    versionLabel: "верзија",

    // === Брз контакт ===
    quickPhone: "Телефон",
    quickPhoneTooltip: "Јавување за прашања",
    quickEmail: "Е-пошта",
    quickEmailTooltip: "Испраќање на е-пошта",
    quickLocation: "Посета",
    quickLocationTooltip: "Посета на нашата локација",
  },
};
